import {
  Time,
  toCamelCaseObject,
  toSnakeCaseObject
} from 'utils';

export enum ProductionState {
  Null = 0,
  Standby,
  Running,
  Done
}

export function productionStateToString(state: ProductionState): string {
  switch (state) {
  case ProductionState.Null:
    return '';
  case ProductionState.Standby:
    return 'standby';
  case ProductionState.Running:
    return 'running';
  case ProductionState.Done:
    return 'done';
  default:
    return '';
  }
}
export function productionStatesToStrings(states: ProductionState[]): string[] {
  return states.map(a => productionStateToString(a));
}

export function stringToProductionState(state: string): ProductionState {
  switch (state) {
  case '':
    return ProductionState.Null;
  case 'standby':
    return ProductionState.Standby;
  case 'running':
    return ProductionState.Running;
  case 'done':
    return ProductionState.Done;
  default:
    throw new Error(`Invalid production state string: ${state}`);
  }
}

export interface Production {
  globalId?: number;
  id?: number;
  deviceId?: number;
  companyId: number;
  factoryId: number;
  quantity: number;
  state?: ProductionState;
  runningAfter?: Date;
  runningTimeFrom?: Date;
  runningTimeTo?: Date;
  productId: number;
  productName: string;
  productModel: string;
  equipmentId: string;
  equipmentName: string;
  equipmentAbbreviation?: string;
}

export function parseProduction(a: any): Production {
  let obj = toCamelCaseObject(a);
  if (obj.state) {
    obj.state = stringToProductionState(obj.state);
  }
  if (obj.runningAfter) {
    obj.runningAfter = Time.dateFromStrAsUtc(obj.runningAfter);
  }
  if (obj.runningTimeFrom) {
    obj.runningTimeFrom = Time.dateFromStrAsUtc(obj.runningTimeFrom);
  }
  if (obj.runningTimeTo) {
    obj.runningTimeTo = Time.dateFromStrAsUtc(obj.runningTimeTo);
  }
  return obj as Production;
}
export function parseProductions(arr: any[]): Production[] {
  return arr?.map(a => parseProduction(a));
}

export function encodeProduction(a: Production): any {
  const obj: any = {...a};
  // TODO: 日付の文字列への変換が必要では？
  return toSnakeCaseObject(obj);
}
